import React, { FC } from "react";
import Sidebar from "./Sidebar/Sidebar";
import Header from "../Header/Header";
import {
  BreakerListDataType,
  breakerListInterface,
} from "typings/navbarBreakerList";
import { useQuery } from "@tanstack/react-query";
import { getBreakerListByUserId } from "api/SidebarList/sidebarList.api";

const Navbar: FC = () => {
  function breakerListArrayWithUrl(arrayList: BreakerListDataType[]) {
    if (Array.isArray(arrayList)) {
      return arrayList.map((breakerItem) => {
        return {
          ...breakerItem,
          url: `/breakers/${breakerItem.gatewayId}/${breakerItem.id.toString()}`,
          gatewayId: breakerItem.gatewayId,
        };
      });
    } else return [];
  }

  //calling api
  const {
    data: breakerItems,
    error,
    isError,
  } = useQuery<BreakerListDataType[], Error, breakerListInterface[]>({
    queryKey: ["breakerList"],
    queryFn: getBreakerListByUserId,
    select: (list) => breakerListArrayWithUrl(list),
    // staleTime: 60000,
    retryDelay: 500,
    retry: 3,
    refetchOnWindowFocus: false,
  });

  if (isError || error)
    console.error(
      "Error while fetching BreakerList Data:",
      error.message || error,
    );

  return (
    <div className="flex flex-col min-h-screen w-full">
      {/* Header */}
      <Header />

      {/* Sidebar and Main Content */}
      <div className="flex-grow">
        <Sidebar breakerList={breakerItems} />
        {/* Add your main content here */}
      </div>

      {/* Footer */}
      {/* <Footer /> */}
    </div>
  );
};

export default Navbar;
